import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/styles/global-variables.css'
import { createPinia } from 'pinia'
import router from './router'
//import { VueReCaptchaPlugin} from 'vue-recaptcha-v3'
import { VueReCaptcha } from 'vue-recaptcha-v3'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

// Install Router
app.use(router)

// Install VueRecaptchaPlugin with its options
app.use(VueReCaptcha, {
    siteKey: '6Lda6qwsAAAAAJY25vpyS7exqZ7FeEdMMa2TYH0x'
, 
    loaderOptions: {
        useReCaptchaNet: true, // for certain countries
        autoHideBadge: true,
    }
})



app.mount('#app')